const safeFindName = (array, filter) => {
  const element = array.find(filter);
  return element === undefined ? undefined : element.name;
};

const parseGeoInfo = (geoData) => {
  const { geoHierarchy, address } = geoData;
  return {
    country: safeFindName(geoHierarchy, (o) => o.level === 'country'),
    region: safeFindName(geoHierarchy, (o) => o.level === 'region'),
    city: safeFindName(geoHierarchy, (o) => o.level === 'city'),
    zipcode: address.zipcode,
  };
};

export default parseGeoInfo;
